import React, { useState } from 'react';
import { IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import ContainerGraphModal from 'components/ContainerGraphModal';
import FeatherIcon from 'components/custom/FeatherIcon';

const InfoDialog = ( { className, title, children } ) => {
  const [open, setOpen] = useState( false );

  return (
    <>
      <IconButton color="primary" className={`square-icon-button-primary2  ${className}`} onClick={() => setOpen( !open )}>
        <FeatherIcon icon="info" color="primary2.main" size="18px" />
      </IconButton>

      <ContainerGraphModal title={title} open={open} onClose={() => setOpen( false )}>
        {children}
      </ContainerGraphModal>
    </>
  );
};

InfoDialog.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

InfoDialog.defaultProps = {
  className: '',
};

export default InfoDialog;

